/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { Container, Row, Col } from 'reactstrap';
import * as default_data from '../config.js'
import { getToken } from '../AuthService.js';
import { getBannerColor } from '../Utils/classification_helper.js';

function SuperAdminUsersLog() {
  const [logs, setLogs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  var loaded_static = false;

  function loadLogs() {
    var token = getToken()
    if(token === false) {
      return;
    }
  
    var user_id = searchParams.get("user_id")
    if(parseInt(Number(user_id)) == user_id && !isNaN(parseInt(user_id, 10))) {      
    }
    else {
        user_id = null;
    }

    fetch(default_data.default_user_service_url_no_cac + '/superadmin-get-all-logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },       
      body: JSON.stringify({
        user_id: user_id,
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            window.location = '/login';
            return;
        }
        data = data.response;
        setLogs(data);
      })
      .catch(error => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    loadLogs()

    }, [])


   const DisplayData=logs.map(
      (info)=>{ 
          return(
            <tr key={info.id}>
                  <td>{info.id}</td>
                  <td>{info.user_id}</td>
                  <td>{info.date_time}</td>
                  <td><a href={`https://whatismyipaddress.com/ip/${info.ip}`} alt={info.ip} target="_blank">{info.ip}</a></td>
                  <td className='table-cell-wrap'>{info.prompt}</td>
                  <td>{info.model}</td>
                  <td>{info.prompt_tokens}</td>
                  <td>{info.completion_tokens}</td>
                  <td>{info.total_tokens}</td>
                  <td className='table-cell-wrap'>{info.response}</td>
                  <td>{
                      info.teach == 'True' ? 'True' : 'False'
                    }
                  </td>
              </tr>
          )
      }
  )    

  return (
    <div>
    { 
      <div className={`header-message ${getBannerColor(true)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'CUI' 
        }
      </div>            
    }
    <div className="reg-page-mode">
    <Container style={{maxWidth: '100%'}}>
      <Row className="justify-content-center reg-page-mode-header">
        <Col xs="12" md="12" lg="12" className="d-flex align-items-center">
          <a href="/" className="d-flex align-items-center">
            <img src="/logo.png" alt="Ask Sage" className="logo" />
          </a>
          <h1 className="user-list-h1">
            Logs
          </h1>
        </Col>
      </Row>
      <Row className="user-list-reg-page-mode-content justify-content-center reg-page-mode-content">
        <Col xs="12" md="12" lg="12">
          <div className="user-list-table-parent">
            <table className="user-list-table table table-striped">
                <thead>
                    <tr>
                      <th>ID</th>
                      <th>User ID</th>
                      <th>Date time</th>
                      <th>IP</th>
                      <th>Prompt</th>
                      <th>Model</th>
                      <th>Prompt Tokens</th>
                      <th>Completion Tokens</th>
                      <th>Total Tokens (AS)</th>
                      <th>Response</th>
                      <th>Train</th>
                    </tr>
                </thead>
                <tbody>                                     
                    {DisplayData}                    
                </tbody>
            </table>
          </div>
          </Col>
      </Row>
      <Row className="justify-content-center reg-page-mode-footer">
        <Col xs="12" md="12" lg="12">
          Copyright &copy; {default_data.default_copywrite_year} Ask Sage, Inc.
        </Col>
      </Row>
      </Container>  
      </div>    
    </div>
  );
}

export default SuperAdminUsersLog;
